<div class="detail-container">
  <nb-card size="large">
    <nb-card-header>
      <div class="header">Gebäudezuweisung</div>
    </nb-card-header>
    <nb-card-body class="contractor-building-assignment-page">
      @if (preselectionMessage(); as message) {
        <wr-banner class="preselection-banner"
                   status="info"
                   data-cy="building-assignment-preselection"
                   [icon]="{ icon: 'info-outline', pack: 'eva' }"
                   [message]="message"></wr-banner>
      }
      <div class="description-header">Wählen Sie einen Dienstleister aus, um die zugewiesenen Gebäude anzuzeigen</div>
      <wr-facility-element-select
        [(ngModel)]="selectedFacilityElement">
      </wr-facility-element-select>
      <nb-select
        class="contractor-select"
        fullWidth
        [placeholder]="'Dienstleister auswählen'"
        [selected]="selectedContractor()"
        (selectedChange)="selectedContractor.set($event)"
      >
        @for (contractor of contractors(); track contractor.id) {
          <nb-option [value]="contractor">
            {{ contractor.name }}
          </nb-option>
        }
      </nb-select>
      <div [nbSpinner]="loading()">
        @if (selectedContractor() && selectedFacilityElement()) {
          <div>
            <div class="team-assign-row">
              <wr-team-select
                [(ngModel)]="selectedTeam"
                [fixedTenantId]="ownerTenantId()">
              </wr-team-select>
              <button
                nbButton
                status="info"
                size="small"
                [disabled]="!selectedTeam()"
                (click)="assignByTeam()">
                Nach Team hinzufügen
              </button>
            </div>
            <wr-generic-pick-list [behaviour]="this"
                                  [initialSearch]="preselectedBuildingSearch()"
                                  [(ngModel)]="selectedBuildingAssignments"
                                  [disabled]="false">
            </wr-generic-pick-list>
          </div>
        }
      </div>
    </nb-card-body>
    <nb-card-footer class="footer">
      <button size="medium" nbButton status="primary" (click)="submit()">Speichern</button>
      <button size="medium" nbButton status="basic" (click)="cancel()">Zurück</button>
    </nb-card-footer>
  </nb-card>
</div>
